import { render, staticRenderFns } from "./LmConfirmationModal.vue?vue&type=template&id=28ae960c&"
import script from "./LmConfirmationModal.vue?vue&type=script&lang=js&"
export * from "./LmConfirmationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports